export enum SearchModeEnum {
  KEYWORD = 'search',
  HYBRID = 'hybrid',
  SEMANTICS = 'semantics',
}
